import { addCallback } from '../lib/teact/teactn';

import type { GlobalState } from './types';

addCallback((_global: GlobalState) => {
  // no-op after removing stories feature
});
